import React from "react";

import { useFamilyRegistrationContext } from "Signups/FamilyRegistration/FamilyRegistrationContext";
import ErrorMessage from "Signups/FamilyRegistration/Shared/ErrorMessage";
import RadioOption from "Signups/FamilyRegistration/Shared/RadioOption/RadioOption";
import useUpdateSetting from "Signups/FamilyRegistration/Shared/useUpdateSetting";

export default function GoToManageMyGiving({
  disabled,
  updatingRadioButtons,
  setUpdatingRadioButtons,
}) {
  const { state } = useFamilyRegistrationContext();
  const { updateSetting, saving, error } = useUpdateSetting();

  const enabled =
    state?.familyRegistrationSettings?.finishedActionManageMyGiving?.enabled;

  async function handleToggle() {
    if (updatingRadioButtons) return;
    setUpdatingRadioButtons(true);

    let postData = {
      setting: "finishedActionManageMyGiving",
      value: !enabled,
    };

    await updateSetting(postData);

    setUpdatingRadioButtons(false);
  }

  return (
    <>
      <RadioOption
        selected={enabled}
        disabled={disabled || (updatingRadioButtons && !saving)}
        id={4}
        label="Take them to the Manage My Giving page"
        loading={saving}
        onClick={handleToggle}
      />

      <ErrorMessage error={error?.error} />
    </>
  );
}
